export enum QuizTypes {
    Slideshow = 1,
    Battleship = 2,
    Jeopardy = 3,
    Sharpshooter = 4
}

export enum QuestionType {
    Text = 1,
    Image = 2,
    Audio = 3,
    Video = 4
}

export enum AuthRoles {
    SuperAdmin = 1,     // Can edit all events and quizzes
    EventAdmin = 2,     // Can edit event this role is linked to and view and edit all event quizzes
    EventCreator = 3    // Can create quizzes in the linked event and edit quizzes created by this user
}

export enum SessionTypes {
    Distributed = 1,
    LivePaperless = 2,
    LiveQuickAnswer = 3,
    LiveShow = 4
}